import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { TrackingCaseListTemplate } from "themes/application/tracking-case/pages";
import { TrackingCaseListViewStore } from "application/tracking-case/stores";

@setCurrentView(rootStore => new TrackingCaseListViewStore(rootStore), "trackingCaseListViewStore")
@observer
class TrackingCaseList extends React.Component {
    render() {
        return <TrackingCaseListTemplate {...this.props} />;
    }
}

export default TrackingCaseList;